/**
 * Retorna os IDs dos elementos DOM.
 * @param {HTMLCollection|Array} elements
 * @returns {string[]}
 */
const getElementsID = (elements = []) => {
  const elementsId = [];

  for (let i = 0; i < elements.length; i++) {
    elementsId.push(elements[i].attributes.getNamedItem("data-id").value);
  }

  return elementsId;
};

/**
 * Retorna o ID de um elemento DOM.
 * @param {Element} element
 * @returns {string}
 */
const getId = (element) => element.attributes.getNamedItem("data-id").value;

/**
 * Retorna a interseção de IDs de nós críticos com os da tela.
 * @param {string[]} nodesId
 * @param {Array} criticalIds
 * @returns {Array<{id: string, type: string}>}
 */
const getIntersectionNodes = (nodesId = [], criticalIds = []) => {
  const inter = criticalIds.filter((item) => nodesId.includes(item.id));
  return inter.map(
    (item) =>
      (item = {
        id: item.id,
        type: item.type,
      })
  );
};

/**
 * Retorna a interseção de IDs de arestas críticas com os da tela.
 * @param {string[]} edgesId
 * @param {Array} criticalIds
 * @returns {Array<{id: string, type: string}>}
 */
const getIntersectionEdges = (edgesId = [], criticalIds = []) => {
  const inter = criticalIds.filter((item) => edgesId.includes(item.id));
  return inter.map(
    (item) =>
      (item = {
        id: item.id,
        type: item.type,
      })
  );
};

/**
 * Adiciona a classe "critical" aos nós DOM que estão no caminho crítico.
 * @param {HTMLCollection|Array} nodes
 * @param {Array} undoFlow
 */
const colorizeNodes = (nodes = [], undoFlow) => {
  const nodesIds = getElementsID(nodes);
  const criticalList = getIntersectionNodes(nodesIds, undoFlow);

  for (let i = 0; i < nodes.length; i++) {
    const isContain = criticalList.find((item) => item.id === getId(nodes[i]));
    if (isContain) {
      nodes[i].classList.add("critical");
    }
  }
};
/**
 * Remove a classe "critical" dos nós DOM.
 * @param {HTMLCollection|Array} nodes
 * @param {Array} undoFlow
 */
const descolorizeNodes = (nodes = [], undoFlow) => {
  const nodesIds = getElementsID(nodes);
  const criticalList = getIntersectionNodes(nodesIds, undoFlow);

  for (let i = 0; i < nodes.length; i++) {
    const isContain = criticalList.find((item) => item.id === getId(nodes[i]));

    if (isContain) {
      nodes[i].classList.remove("critical");
    }
  }
};

/**
 * Colore as arestas DOM que estão no caminho crítico.
 * @param {HTMLCollection|Array} edges
 * @param {Array} undoFlow
 */
const colorizeEdges = (edges = [], undoFlow) => {
  const edgesIds = getElementsID(edges);
  const criticalList = getIntersectionEdges(edgesIds, undoFlow);

  for (let i = 0; i < edges.length; i++) {
    const isContain = criticalList.find((item) => item.id === getId(edges[i]));
    if (isContain) {
      if (!edges[i].hasAttribute("data-previous-stroke")) {
        edges[i].setAttribute(
          "data-previous-stroke",
          edges[i].style.stroke || ""
        );
      }
      edges[i].style.stroke = "#D93333";
      edges[i].style.strokeWidth = "4px";
    }
  }
};

/**
 * Remove a coloração das arestas DOM.
 * @param {HTMLCollection|Array} edges
 */
const descolorizeEdges = (edges = []) => {
  for (let i = 0; i < edges.length; i++) {
    if (edges[i].hasAttribute("data-previous-stroke")) {
      edges[i].style.stroke = edges[i].getAttribute("data-previous-stroke");
      edges[i].removeAttribute("data-previous-stroke");
    }
    edges[i].style.strokeWidth = "1px";
  }
};

export { colorizeNodes, descolorizeNodes, colorizeEdges, descolorizeEdges };
